import React from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
interface QtyStepperProps {
  value: number;
  label: string;
  onStep: (delta: number) => void;
  onChange: (value: number) => void;
}
const btnClass = 'flex h-10 w-9 items-center justify-center text-navy-800 transition-colors duration-150 ease-out hover:text-accent-600 disabled:text-steel-400 sm:h-11 sm:w-10';
export function QtyStepper({
  value,
  label,
  onStep,
  onChange
}: QtyStepperProps) {
  const active = value > 0;
  return <div className={`flex shrink-0 items-center overflow-hidden rounded-md border transition-colors duration-150 ease-out ${active ? 'border-accent-500 bg-accent-500/5' : 'border-steel-200 bg-white'}`} data-id="element-225" data-mp="utvebkf5fprx">
      <button type="button" onClick={() => onStep(-1)} disabled={!active} aria-label={`Quitar una pieza de ${label}`} className={btnClass} data-id="element-226" data-mp="14iwr71qedr1o">
        <MinusIcon className="h-4 w-4" aria-hidden="true" data-id="element-227" data-mp="1djuzhw7vckq2" />
      </button>
      <input type="number" inputMode="numeric" min={0} value={value === 0 ? '' : value} placeholder="0" aria-label={`Piezas de ${label}`} onChange={e => onChange(parseInt(e.target.value || '0', 10))} className="h-10 w-10 min-w-0 border-0 bg-transparent p-0 text-center font-semibold text-navy-900 placeholder:text-steel-400 focus:outline-none focus:ring-0 sm:h-11 sm:w-11 [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none" data-id="element-228" data-mp="23bewsu4zpo8r" />
      <button type="button" onClick={() => onStep(1)} aria-label={`Agregar una pieza de ${label}`} className={btnClass} data-id="element-229" data-mp="2h3v1s0hgbwcb">
        <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-230" data-mp="2ca0ekn2n0z8h" />
      </button>
    </div>;
}